import React, { useMemo } from "react";
import { Descriptions } from "antd";
import moment from "moment";
import { formatPrice, formatDistance } from "@/utils/utils";
import VehiclesSummaryList from "./VehiclesSummaryList";
const ShipmentRequirementsSummaryItem = ({ shipmentData }) => {
    const { distance, pickupAddress, dropOffAddress, transporterPricePerMile, totalTransporterPrice } = shipmentData;
    const availability = useMemo(() => {
        if (!shipmentData?.availableAt) {
            return "";
        }
        const now = moment();
        const availableAt = moment.utc(shipmentData?.availableAt);
        if (availableAt.isAfter(now)) {
            return availableAt.format("M/D/YY");
        }
        return "Available Now";
    }, [shipmentData]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Descriptions, { style: { marginTop: 16 }, layout: "horizontal" },
            React.createElement(Descriptions.Item, { label: "Total Price" }, formatPrice(totalTransporterPrice)),
            React.createElement(Descriptions.Item, { label: "Price Per Mile" }, formatPrice(transporterPricePerMile)),
            React.createElement(Descriptions.Item, { label: "Distance" }, `${formatDistance(distance)} miles`)),
        React.createElement(Descriptions, { style: { marginTop: 16 }, layout: "vertical" },
            React.createElement(Descriptions.Item, { label: "Pickup Address" }, pickupAddress ? `${pickupAddress.simplifyAddress}, ${pickupAddress.zipCode}` : "N/A"),
            React.createElement(Descriptions.Item, { label: "Pickup Instructions" }, pickupAddress.notes ? pickupAddress.notes : "N/A"),
            React.createElement(Descriptions.Item, { label: "Availability" }, availability)),
        React.createElement(Descriptions, { style: { marginTop: 16 }, layout: "vertical" },
            React.createElement(Descriptions.Item, { label: "DropOff Address" }, dropOffAddress ? `${dropOffAddress.simplifyAddress}, ${dropOffAddress.zipCode}` : "N/A"),
            React.createElement(Descriptions.Item, { label: "DropOff Instructions" }, dropOffAddress.notes ? dropOffAddress.notes : "N/A")),
        React.createElement(VehiclesSummaryList, { shipment: shipmentData })));
};
export default ShipmentRequirementsSummaryItem;
